import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8AdMyVision from '../../components/A8/A8AdMyVision';
import CATEGORY_IMAGE from '../../../static/biz-professional/tori-1976609_1280.jpeg';
import { useNavigate } from 'react-router-dom';
import GL_IMAGE from '../../../static/biz-professional/GalleryLambda-Slide-Structure-Advanced.png';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            第5回: トップメッセージとボトムメッセージを使いわけよう（中級）
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Published on 2024 Jan 17th <br />
                            10 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            これまで4回に渡り、プレゼンテーションのフォーマットや大事な考え方を説明してきました。プレゼンテーションにおけるイシュー、スライドの構成要素、トップメッセージの重要性、
                            みなさんはすでにこれらを理解していると思います。第4回では、デザインによって強調すべき項目をコントロールするすべを学びました。<br /><br />

                            第5回の今回は、実は第3回の応用編です。第3回ではスライドにおけるトップメッセージの出し方を学びましたね。そのメッセージは単なるファクトではなく、
                            収集したファクトの分析を通じた、あなたなりの解釈であることを理解していただいていたかと思います。そのトップメッセージがクリスタライズされているほど、プレゼンテーションの価値は高くなります。<br /><br />

                            さて、今日は前回までに説明してきたトップメッセージの使い方に補足する形で、ボトムメッセージの使い所とコツをお伝えしたいと思います。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            トップメッセージとボトムメッセージを使いわけよう（中級）
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px', fontWeight: 'lighter' }}>Table of Contents</Typography>
                    </CardContent>
                    <ol>
                        <li><a href="#1">そもそもボトムメッセージとは。</a></li>
                        <li><a href="#2">ボトムメッセージの使い所。</a></li>
                        <li><a href="#3">最後に一言。</a></li>
                    </ol>
                    <Divider id="1" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>そもそもボトムメッセージとは。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            トップメッセージとボトムメッセージときいて、その意味するところをぱっとわかる人は少ないかもしれません。ここでも、実例を見ながら説明していきましょう。
                            <br />
                            <br />

                            <CardMedia
                                component="img"
                                sx={{

                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE}
                                alt="image of the category"
                            />

                        </Typography>
                    </CardContent>
                    <br />

                    <Divider id="2" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>ボトムメッセージの使い所。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            まず、ボトムメッセージとは何かがわかったところで、トップメッセージとの棲み分け、ならびにボトムメッセージの使い所を説明していきます。<br /><br />

                            改めて、トップメッセージはボディに記載してあるファクトから導き出せる結論・メッセージとして読者に伝えたいことである、とお伝えしてきました。あくまでも一般論・セオリーとして、
                            ボトムメッセージはそのトップメッセージを踏まえて、さらに伝えたいことがある場合に利用することが多いです。<br /><br />

                            別の言い方をすると、トップメッセージは「ファクトから導き出せる結論として90%~100%の自信で言えること」であり、
                            ボトムメッセージは「ファクトから導き出せる結論として70%~100%の自信で言えること」と説明されることが多い気がします。つまりボトムメッセージは示唆であって、必ずしも正しいかどうかはわからないけれど、
                            プロフェッショナルな判断としてこうなのではないかという、あなたなりの究極的なメッセージです。<br /><br />

                            <br />
                            <Card elevation={3}>
                                <CardContent>
                                    <Typography variant="h4" style={{ fontSize: '22px' }}>コラム - 不確実性とメッセージ </Typography>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        <br /> ビジネスの場では常に厳しい判断が求められます。90％の情報で意思決定をすることもあれば、50％の情報で意思決定を迫れることもあります。
                                        数千億円規模の企業買収や、負債を抱えた企業の経営戦略立案など、限られた情報と時間の中での意思決定は簡単ではありません。経験上、不確実性が高い状況における意思決定において
                                        トップメッセージとボトムメッセージの使い分けは非常に有効です。<br /><br />

                                        トップメッセージではファクトから導き出せるメッセージを記載し（とはいえ、何度もお伝えしているようにトップメッセージはファクトそのものであるべきではないので、
                                        トップメッセージであってもプロフェッショナルジャッジメントが入っているべきです。つまり、不確実性がある中で、あなたなりの結論を出しているべきです。）そして、もっと踏み込んだメッセージ -
                                        プロフェッショナルとして提言・意見・解釈が入っている渾身の一文 - そんなメッセージをボトムメッセージに記載してみてください。
                                    </Typography>
                                </CardContent>
                            </Card>
                            <br />
                            <br />

                            なお、ボトムメッセージは全てのスライドに必要ではありません。むしろ、ほとんどのスライドはトップメッセージだけで十分です。トップメッセージよりも踏み込んだメッセージを記載したい際、
                            ボトムメッセージを活用してみてください。<br /><br />

                            <CardContent>
                                <TipsAndUpdatesIcon /> ここで、戦略コンサルティングファームであるBain & Companyの公開資料のリンクを下記にご紹介します。P21ページにボトムメッセージの一例がみて取れます。
                                <blockquote>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:Bain & Company <a href="https://media.bain.com/Images/2011%20Bain%20China%20Luxury%20Market%20Study.pdf" target="_blank" rel="noopener noreferrer"> media.bain.com </a> (p21)
                                    </Typography>
                                </blockquote>
                            </CardContent>
                        </Typography>
                    </CardContent>


                    <Divider id="4" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最後に一言</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            プレゼンテーションでは複雑な情報や不確実性の高い情報で、結論を求められるも多いかと思います。とても難しい意思決定ですよね。
                            そんな際には、本記事を参考にし、「思い切りと自信をもってプロフェショナルな判断を記載する」ことにつながれば幸いです。不確実なことを文字に起こすのは勇気がいる行為ですが、
                            あなたのユニークな視点でのメッセージを届けることで、きっとより深みのあるディスカッションを齎すことができるでしょう。
                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8AdMyVision />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
